<template>
  <Layout>
    <div class="row mb-lg-5">
    <div class="row mb-lg-5">
      <div class="col-xl-12 mb-lg-5" >
        
        <div class="row mb-lg-5">
          <b-badge v-for="(chip, index) in schoolclasses" :key="index" class="chip col-sm-1 col-6 mx-auto btn-success">{{ chip.name }}</b-badge>
        </div>

        <div class="row mb-lg-5">
          <div class="col-sm-4">
            <div class="card shadow-sm">
            <div class="card-body">
              <div class="media">
                <div class="media-body"><p class="text-muted fw-medium mb-2">Admissions</p><h4 class="mb-0">{{commas(admissions)}} </h4></div>
                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                  <span class="avatar-title"><i class="mdi mdi-book font-size-24"></i></span>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div class="col-sm-4">
            <div class="card shadow-sm">
            <div class="card-body">
              <div class="media">
                <div class="media-body"><p class="text-muted fw-medium mb-2">Approved</p><h4 class="mb-0">{{commas(approved)}}</h4></div>
                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                  <span class="avatar-title"><i class="mdi mdi-account-check font-size-24"></i></span>
                </div>
              </div>
            </div>
          </div>
          </div>
          <div class="col-sm-4">
            <div class="card shadow-sm">
            <div class="card-body">
              <div class="media">
                <div class="media-body"><p class="text-muted fw-medium mb-2">Pending</p><h4 class="mb-0">{{commas(pending)}} </h4></div>
                <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                  <span class="avatar-title"><i class="mdi mdi-close font-size-24"></i></span>
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { schoolclassMethods, schoolclassComputed, } from "@/state/helpers";

export default {
  page: {
    title: "Dashboard",
    meta: [{name: "description",content: appConfig.description}],
  },
  components: {  Layout },
  data() {
    return {
    admissions:0,
    pending:0,
    approved:0,
    };
  },
  mounted() {
    this.todaysanalysis();
    this.fetchSchoolClasses();
  },
  computed: {
    ...schoolclassComputed,
  },
  methods: {
    ...schoolclassMethods,
    commas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
    async todaysanalysis(){
      let url = `/myanalysis`;
      await axios.get(url).then((response) => {
        this.admissions = response.data.admissions;
        this.pending = response.data.pending;
        this.approved = response.data.approved;
      });
    },
  },
};
</script>

<style scoped>
.chip {
  margin: 0.25rem;
  padding: 0.5rem 0.75rem;
  display: inline-flex;
  align-items: center;
}
</style>